import { call, put } from 'redux-saga/effects';
import { workListDataActions as actions } from './index';
import { request } from '../../../../utils/request';
import { WorkListDataState } from './types';
import { apiList } from '../../../../locales/apiList';
import moment from 'moment';

export function* getWorkList() {
  // yield delay(1000); //get new token first
  const requestURL = `${process.env.REACT_APP_WEB_BI_API_URL}${apiList.getWorklistURL}?allPending=true&contractType=New,Renew`;
  try {
    // Call our request helper (see 'utils/request')
    const repos: WorkListDataState[] = yield call(request, requestURL);

    if (repos && repos.length > 0) {
      const initDate = repos
        .sort((a, b) => {
          return moment(a.createdAt).unix() - moment(b.createdAt).unix();
        })[0].createdAt;

      yield put(actions.updateHistoryDate(moment(initDate).format('YYYY-MM-DD')));
      yield put(actions.reposLoaded(repos));
    } else {
      yield put(actions.updateHistoryDate(moment().format('YYYY-MM-DD')));
      yield put(actions.reposLoaded([]));
    }
  } catch (err) {
    // if (err.response?.status === 404) {
    //   yield put(actions.repoError(RepoErrorType.USER_NOT_FOUND));
    // } else if (err.message === 'Failed to fetch') {
    //   yield put(actions.repoError(RepoErrorType.GITHUB_RATE_LIMIT));
    // } else {
    //   yield put(actions.repoError(RepoErrorType.RESPONSE_ERROR));
    // }
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* workListDataSaga() {
  // Watches for loadRepos actions and calls getRepos when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied.
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount
  yield getWorkList();
  // yield takeLatest(actions.changeCustomerName.type, getRepos);
}
